// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SortDescendingOutlinedSvg from "@fishx/icons-svg/es/asn/SortDescendingOutlined";
import FishxIcon from '../components/FishxIcon';

var SortDescendingOutlined = function SortDescendingOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SortDescendingOutlinedSvg
  }));
};

SortDescendingOutlined.displayName = 'SortDescendingOutlined';
export default React.forwardRef(SortDescendingOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SortDescendingOutlined.js
// module id = 4174
// module chunks = 0